import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'

Vue.use(Vuex)

function normalizeRoles(role) {
  if (!role) return 'ROLE_USER'
  const upper = role.toUpperCase()
  return upper.startsWith('ROLE_') ? upper : 'ROLE_' + upper
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: (() => {
      try { return JSON.parse(localStorage.getItem('user') || '{}') } catch (e) { return {} }
    })(),
    roles: (() => {
      let raw = []
      try { raw = JSON.parse(localStorage.getItem('roles') || '[]') } catch (e) { raw = [] }
      const normalized = raw.map(normalizeRoles)
      if (JSON.stringify(raw) !== JSON.stringify(normalized)) {
        localStorage.setItem('roles', JSON.stringify(normalized))
      }
      return normalized
    })()
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isAdmin: state => state.roles.some(r => r === 'ROLE_ADMIN' || r === 'ROLE_SUPER_ADMIN'),
    userName: state => state.user.name || state.user.username || 'User',
    userEmail: state => state.user.email || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_ROLES(state, roles) {
      state.roles = roles
      localStorage.setItem('roles', JSON.stringify(roles))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = {}
      state.roles = []
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('roles')
    }
  },
  actions: {
    async login({ commit }, { email, password }) {
      const response = await request.post('/api/admin/login', { email, password })
      const data = response.data
      commit('SET_TOKEN', data.token)
      commit('SET_USER', data.user)
      commit('SET_ROLES', data.user.roles || [normalizeRoles(data.user.role)])
      return data
    },
    async logout({ commit }) {
      try {
        await request.post('/api/admin/logout')
      } finally {
        commit('CLEAR_AUTH')
      }
    },
    async fetchUserInfo({ commit }) {
      try {
        const response = await request.get('/api/admin/info')
        const data = response.data
        commit('SET_USER', data)
        if (data.roles) commit('SET_ROLES', data.roles)
        else if (data.role) commit('SET_ROLES', [normalizeRoles(data.role)])
      } catch {
        // Not critical, user already has info from login
      }
    },
    async frontLogin({ commit }, { username, password }) {
      const response = await request.post('/api/auth/login', { username, password })
      const data = response.data
      commit('SET_TOKEN', data.token)
      const userData = {
        id: data.id,
        name: data.username,
        username: data.username,
        email: data.email
      }
      commit('SET_USER', userData)
      const roles = data.roles && data.roles.length ? data.roles.map(normalizeRoles) : [normalizeRoles(data.role)]
      commit('SET_ROLES', roles)
      return data
    },
    frontOAuthLogin({ commit }, { token, username, email, id }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', {
        id,
        name: username,
        username,
        email
      })
      commit('SET_ROLES', ['ROLE_USER'])
    }
  }
})
